import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInAndUp } from 'supertokens-web-js/recipe/thirdparty';
import RoutePaths from '../../router/RoutePaths';
import { message } from 'antd';
import TaskonioLoader from '../../components/UI/Loader';
import { AnalyticsEvent } from '../../analytics/analyticsEvent';
import { analytics } from '../../analytics/analytics';
import { getMagicLinkRedirectEmail, MagicLinkRedirectState } from '../../common/signUpMethod';

const GoogleCallbackPage: React.FC = () => {
  const navigate = useNavigate();

  async function handleGoogleCallback() {
    try {
      const response = await signInAndUp();

      if (response.status === 'OK') {
        if (response.createdNewRecipeUser && response.user.loginMethods.length === 1) {
          // sign up successful
          navigate(RoutePaths.LoginSelectOrganization);
          analytics.identify(response.user.id);
          analytics.track(AnalyticsEvent.accountCreated, {
            loginMethod: 'google',
          });
        } else {
          // sign in successful
          navigate(RoutePaths.LoginSelectOrganization);
        }
      } else if (response.status === 'SIGN_IN_UP_NOT_ALLOWED') {
        // The account was created with a magic link: Login sends one to this email instead.
        const magicLinkRedirectEmail = getMagicLinkRedirectEmail(response.reason);
        if (magicLinkRedirectEmail) {
          const state: MagicLinkRedirectState = { magicLinkRedirectEmail };
          navigate(RoutePaths.Login, { replace: true, state });
        } else {
          void message.error(response.reason);
        }
      } else {
        // SuperTokens requires that the third party provider
        // gives an email for the user. If that's not the case, sign up / in
        // will fail.

        // As a hack to solve this, you can override the backend functions to create a fake email for the user.

        void message.error('No email provided by social login. Please use another form of login');
        navigate(RoutePaths.Login);
      }
    } catch (err: any) {
      if (err.isSuperTokensGeneralError === true) {
        // this may be a custom error message sent from the API by you.
        void message.error(err.message);
      } else {
        void message.error('Something went wrong. Please try again later.');
      }
    }
  }

  useEffect(() => {
    handleGoogleCallback();
  }, []);

  return (
    <div className="flex items-center justify-center">
      <TaskonioLoader></TaskonioLoader>
    </div>
  );
};

export default GoogleCallbackPage;
